@if (isLoading()) {
  <app-spinner-filled />
} @else if (questionnaire(); as questionnaire) {
  <app-alerts />

  <div class="mx-auto w-full max-w-[58rem] px-4 pt-6 pb-16 lg:px-0">
    <div class="flex items-center gap-5">
      <div class="size-20 shrink-0">
        @if (questionnaire.logoUrl) {
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="questionnaire.logoAlt || questionnaire.name"
              [fill]="true"
              [ngSrc]="questionnaire.logoUrl!"
              class="object-contain" />
          </app-image-thumbnail>
        }
      </div>

      <div class="min-w-0">
        <h1
          class="!mb-0 font-[Poppins] text-3xl font-bold tracking-[0.02em] text-black uppercase md:text-4xl">
          EDYCJA: {{ questionnaire.name }}
        </h1>
      </div>
    </div>

    <div class="mt-10 text-[#242424]">
      Wybierz kosmetyki do swojego boxa w zamówieniu:
    </div>

    @if (questionnaire.description) {
      <p class="mt-5 max-w-4xl text-gray-600">
        {{ questionnaire.description }}
      </p>
    }

    <div class="mt-8 max-w-4xl rounded-2xl bg-[#fff4f8] p-4">
      <app-box-questionnaire-availability
        [createdAt]="questionnaire.createdAt"
        [endDate]="questionnaire.endDate"
        [isEnding]="isEnding()"
        [status]="questionnaire.status" />
    </div>

    <div class="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
      <span class="font-semibold text-[#dc6b95]">
        {{ questionnaire.orderNumber }}
      </span>

      @if (isEditable) {
        @for (
          recommendedQuestionnaire of questionnaire.recommendedQuestionnaires;
          track recommendedQuestionnaire.id
        ) {
          <button
            type="button"
            class="inline-flex items-center gap-2 font-semibold text-[#3858E9] underline decoration-dotted underline-offset-4 transition hover:text-[#2740b2]"
            (click)="
              handleQuestionnaireNavigation(recommendedQuestionnaire.id)
            ">
            <span>{{ recommendedQuestionnaire.name }}</span>

            @if (
              recommendedQuestionnaire.status === BoxQuestionnaireStatus.Filled
            ) {
              <span class="text-xs tracking-[0.08em] text-gray-500 uppercase">
                <app-icon
                  [icon]="Icon.CheckCircleFill"
                  class="text-lg text-[#dc6b95]" />
              </span>
            }
          </button>
        }
      }
    </div>

    <div class="mt-10 flex flex-col gap-12">
      @for (
        question of questionnaire.questions;
        track question.id;
        let index = $index
      ) {
        <section>
          <div class="mb-5">
            <h2
              class="flex items-center gap-3 font-medium tracking-[0.08em] text-[#232323] uppercase">
              <span>{{ questionLabel(question, index) }}</span>

              @if (isQuestionSelected(question)) {
                <app-icon
                  [icon]="Icon.CheckCircleFill"
                  class="text-lg text-[#dc6b95]" />
              }
            </h2>
          </div>

          <div class="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            @for (option of question.options; track option.id) {
              <article
                class="flex h-full flex-col border border-[#ece8e4] bg-white p-4 shadow-[0_0_0_1px_rgba(0,0,0,0.02)]">
                <div class="relative aspect-square">
                  @if (option.imageUrl) {
                    <app-image-thumbnail
                      [rounded]="false"
                      size="full">
                      <img
                        [alt]="option.imageAlt || option.name"
                        [fill]="true"
                        [ngSrc]="option.imageUrl!"
                        class="object-contain" />
                    </app-image-thumbnail>
                  }
                </div>

                <div class="flex flex-1 flex-col pt-5">
                  @if (option.sourceName) {
                    <div class="font-semibold text-[#1b1b1b] uppercase">
                      {{ option.sourceName }}
                    </div>
                    <div class="pt-3 text-sm text-[#1b1b1b] uppercase">
                      {{ option.name }}
                    </div>
                  } @else {
                    <div class="font-semibold text-[#1b1b1b] uppercase">
                      {{ option.name }}
                    </div>
                  }
                </div>

                <div class="flex flex-1 flex-col">
                  <div class="text-xs font-bold text-[#1b1b1b]">
                    @for (attribute of option.attributes; track attribute.id) {
                      <div>{{ attribute.value }}</div>
                    }
                  </div>
                </div>

                <div class="mt-6">
                  <app-slim-button
                    (clickEvent)="handleOptionClick(question.id, option)"
                    [disabled]="optionIsDisabled(option)"
                    [label]="optionActionLabel(question.id, option)"
                    [loading]="optionIsSaving(question.id, option.id)"
                    [theme]="optionButtonTheme(question.id, option)"
                    maxWidth="100%" />
                </div>
              </article>
            }
          </div>
        </section>
      }
    </div>

    @if (isEditable) {
      <div class="mt-12 max-w-5xl text-[#3a3a3a]">
        Każda zmiana zapisuje się automatycznie. Nie masz faworyta? Jeśli nie
        zaznaczysz żadnego produktu, z przyjemnością wybierzemy go za Ciebie i
        zrobimy Ci niespodziankę!
      </div>

      <div class="mt-6 font-semibold text-[#dc6b95]">
        Ilość ankiet pozostałych jeszcze do wypełnienia:
        {{ remainingCount() }}.
      </div>
    }
  </div>
}
